<template>
    <div id="app" ondragstart="return false">
        <router-view/>
        <!-- mask -->
        <gallery-mask></gallery-mask>
    </div>
</template>

<script>
import GalleryMask from "./components/Mask/GalleryMask"

export default {
    name: "app",
    components: {
        GalleryMask
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
